import { createSlice } from "@reduxjs/toolkit"

const userSlice = createSlice({
    name: 'user',
    initialState: {
        details: null,
    },
    reducers: {
        setUserDetails: (state, action) => { 
            state.details = action.payload;
         },
        clearUserData: (state) => { 
            state.details = null;
        },
    },
})

// Extract and export each action creator by name
export const { setUserDetails, clearUserDetails } = userSlice.actions
// Export the reducer, either as a default or named export
export default userSlice.reducer